import { formatColor } from '@meitu/saas-colors';
import { getConfigAssets } from '@/i18n/assets';
// TODO: 是否替换为 loadAssets ？
import qrCodeImg1 from './assets/q1.png';
import qrCodeImg2 from './assets/q2.png';
import qrCodeImg3 from './assets/q3.png';
import qrCodeImg4 from './assets/q4.png';
import qrCodeImg5 from './assets/q5.png';
import qrCodeImg6 from './assets/q6.png';
import qrCodeImg7 from './assets/q7.png';
import qrCodeImg8 from './assets/q8.png';
import qrCodeImg9 from './assets/q9.png';

const qrCodeImgList = [
    qrCodeImg1,
    qrCodeImg2,
    qrCodeImg3,
    qrCodeImg4,
    qrCodeImg5,
    qrCodeImg6,
    qrCodeImg7,
    qrCodeImg8,
    qrCodeImg9,
];

export const codeTransform = {
    left: 0,
    top: 0,
    width: 76,
    height: 76,
};

export const codeInfo = () => {
    return {
        ...getConfigAssets().qrCode,
        fill: '#ffffffff',
    };
};

export const codeListConf = [
    { stroke: '#000000ff', strokeGradient: null },
    { stroke: '#f97373ff', strokeGradient: null },
    { stroke: '#75d39bff', strokeGradient: null },
    { stroke: '#e898edff', strokeGradient: null },
    { stroke: '#79c4fbff', strokeGradient: null },
    { stroke: '#a4a9ffff', strokeGradient: null },
    {
        stroke: '',
        strokeGradient: {
            colors: [
                {
                    color: '#e6b582ff',
                    value: 0,
                },
                {
                    color: '#ecd6b2ff',
                    value: 1,
                },
            ],
            angle: 90,
        },
    },
    {
        stroke: '',
        strokeGradient: {
            colors: [
                {
                    color: '#66c5e9ff',
                    value: 0,
                },
                {
                    color: '#7ce2a8ff',
                    value: 1,
                },
            ],
            angle: 90,
        },
    },
    {
        stroke: '',
        strokeGradient: {
            colors: [
                {
                    color: '#85cafeff',
                    value: 0,
                },
                {
                    color: '#ef77edff',
                    value: 1,
                },
            ],
            angle: 25,
        },
    },
];

const coverList: {
    index: number;
    key: string;
    colors: { fill: string; stroke: string };
}[] = [];
codeListConf.forEach((item, index) => {
    const strokeValue = item.strokeGradient ? (formatColor(item.strokeGradient) as string) : item.stroke;
    coverList.push({
        index,
        colors: { fill: codeInfo().fill, stroke: strokeValue },
        key: `${codeInfo().fill}${strokeValue}`,
    });
});

export function getQrCodeImage(index: number, width: number, height: number) {
    return <img src={qrCodeImgList[index]} width={width} height={height} />;
}

export const qrCodeCoverList = coverList;
